import React from 'react';
import { CellContext } from '@tanstack/table-core';
import { Moment } from 'moment';

import { Typography } from '../../../../Typography';

export interface IDatesCellProps {
    cell: CellContext<any, (Moment | null | undefined)[]>;
}

export const DatesCell = ({ cell }: IDatesCellProps) => {
    const formatted = (cell.getValue() ?? [])
        .filter((value): value is Moment => Boolean(value))
        .map((value) => value.format('D. M. YYYY'))
        .join(', ');

    if (!formatted) {
        return null;
    }

    return <Typography>{formatted}</Typography>;
};
